import { Model } from '../parents/model';

export class StoresCustomerModel extends Model {
  static ATTR_ADDITIONAL_PARAMS = 'additional_params';
  static ATTR_BANK_ACCOUNT_IBAN = 'bank_account_iban';
  static ATTR_BANK_ACCOUNT_NUMBER = 'bank_account_number';
  static ATTR_BANK_CODE = 'bank_code';
  static ATTR_BANK_SWIFT_CODE = 'bank_swift_code';
  static ATTR_BIRTH_AT = 'birth_at';
  static ATTR_CODE = 'code';
  static ATTR_CREATED_AT = 'created_at';
  static ATTR_EMAIL = 'email';
  static ATTR_FIRST_NAME = 'first_name';
  static ATTR_GENDER_ORIENTED_PRODUCT_PREFERENCE = 'gender_oriented_product_preference';
  static ATTR_ID = 'id';
  static ATTR_IS_ACTIVE = 'is_active';
  static ATTR_IS_BLOCKED = 'is_blocked';
  static ATTR_LAST_LOGGED_AT = 'last_logged_at';
  static ATTR_LAST_NAME = 'last_name';
  static ATTR_PHONE = 'phone';
  static ATTR_RESTRICT_TO_COUNTRY_ID = 'restrict_to_country_id';


  get additionalParams() {
    return this.attributes[StoresCustomerModel.ATTR_ADDITIONAL_PARAMS];
  }
  get bankAccountIban() {
    return this.attributes[StoresCustomerModel.ATTR_BANK_ACCOUNT_IBAN];
  }
  get bankAccountNumber() {
    return this.attributes[StoresCustomerModel.ATTR_BANK_ACCOUNT_NUMBER];
  }
  get bankCode() {
    return this.attributes[StoresCustomerModel.ATTR_BANK_CODE];
  }
  get bankSwiftCode() {
    return this.attributes[StoresCustomerModel.ATTR_BANK_SWIFT_CODE];
  }
  get birthAt() {
    return this.attributes[StoresCustomerModel.ATTR_BIRTH_AT];
  }
  get code() {
    return this.attributes[StoresCustomerModel.ATTR_CODE];
  }
  get createdAt() {
    return this.attributes[StoresCustomerModel.ATTR_CREATED_AT];
  }
  get email() {
    return this.attributes[StoresCustomerModel.ATTR_EMAIL];
  }
  get firstName() {
    return this.attributes[StoresCustomerModel.ATTR_FIRST_NAME];
  }
  get genderOrientedProductPreference() {
    return this.attributes[StoresCustomerModel.ATTR_GENDER_ORIENTED_PRODUCT_PREFERENCE];
  }
  get id() {
    return this.attributes[StoresCustomerModel.ATTR_ID];
  }
  get isActive() {
    return this.attributes[StoresCustomerModel.ATTR_IS_ACTIVE];
  }
  get isBlocked() {
    return this.attributes[StoresCustomerModel.ATTR_IS_BLOCKED];
  }
  get lastLoggedAt() {
    return this.attributes[StoresCustomerModel.ATTR_LAST_LOGGED_AT];
  }
  get lastName() {
    return this.attributes[StoresCustomerModel.ATTR_LAST_NAME];
  }
  get phone() {
    return this.attributes[StoresCustomerModel.ATTR_PHONE];
  }
  get restrictToCountryId() {
    return this.attributes[StoresCustomerModel.ATTR_RESTRICT_TO_COUNTRY_ID];
  }
}
